import { Directive } from '@angular/core';

import { PreloaderClassNames } from '@hdms/shared/common-types';
import { PlatformService, PreloaderService, WindowRefService } from '@hdms/shared/util-core';

import { PreloaderComponentAbstract } from './preloader-component.abstract';

@Directive({
  selector: '[shrdUicPagePreloader]'
})
export class PagePreloaderDirective extends PreloaderComponentAbstract {
  private readonly bodyElement: HTMLBodyElement;

  constructor(preloaderService: PreloaderService, winRef: WindowRefService, platformService: PlatformService) {
    super(winRef, platformService);

    this.preloaderElement = this.win.document.querySelector(`.${PreloaderClassNames.PAGE_PRELOADER}`);
    this.bodyElement = this.win.document.body;

    if (this.preloaderElement) {
      this.createStatusSubscription(preloaderService.loadingStatus);
    }
  }

  protected show(): void {
    super.show();
    this.bodyElement.classList.add(PreloaderClassNames.BODY_ACTIVE);
  }

  protected resetClassNames(event: Event): void {
    super.resetClassNames(event);
    if (event) {
      this.bodyElement.classList.remove(PreloaderClassNames.BODY_ACTIVE);
      // can be listened to in HOL legacy (e.g. to update sticky header offset)
      this.win.document.dispatchEvent(new CustomEvent('hdms.pagePreloader.removed'));
    }
  }
}
